import {API} from './API';

export class ProfitTargetService {
  async getTarget(year) {
    return (await API.getConnection())
      .get(`profit-targets/${year}`)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async saveTarget(data) {
    let method = 'post';
    let url = 'profit-targets';
    if (data.id) {
      method = 'put';
      url = `${url}/${data.year}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
